import { Editor } from "@tiptap/core"
import { Blockquote } from "@tiptap/extension-blockquote"
import { CodeBlock } from "@tiptap/extension-code-block"
import { Heading } from "@tiptap/extension-heading"
import { HorizontalRule } from "@tiptap/extension-horizontal-rule"
import { BulletList, OrderedList, TaskList } from "@tiptap/extension-list"
import { useEditorState } from "@tiptap/react"

import { HeadingLevel } from "../enums"
import { useNodeSchemaWarning } from "./editor"

export const useBlockqouteState = (editor: Editor) => {
	useNodeSchemaWarning(Blockquote.name, editor)
	return useEditorState({
		editor,
		selector: () => {
			return {
				isActive: editor.isActive(Blockquote.name),
				canToggle: editor.can().toggleBlockquote(),
				canSet: editor.can().setBlockquote(),
				canUnset: editor.can().unsetBlockquote(),
			}
		},
	})
}
export const useBulletListState = (editor: Editor) => {
	useNodeSchemaWarning(BulletList.name, editor)
	return useEditorState({
		editor,
		selector: () => {
			return {
				isActive: editor.isActive(BulletList.name),
				canToggle: editor.can().toggleBulletList(),
			}
		},
	})
}
export const useCodeBlockState = (editor: Editor) => {
	useNodeSchemaWarning(CodeBlock.name, editor)
	return useEditorState({
		editor,
		selector: () => {
			return {
				isActive: editor.isActive(CodeBlock.name),
				canToggle: editor.can().toggleCodeBlock(),
				canSet: editor.can().setCodeBlock(),
			}
		},
	})
}
export const useHeadingState = (editor: Editor) => {
	useNodeSchemaWarning(Heading.name, editor)
	return useEditorState({
		editor,
		selector: () => {
			return {
				level: (editor.getAttributes(Heading.name).level ?? undefined) as HeadingLevel,
				isActive: (level: HeadingLevel) => editor.isActive(Heading.name, { level }),
				canToggle: (level: HeadingLevel) => editor.can().toggleHeading({ level }),
				canSet: (level: HeadingLevel) => editor.can().setHeading({ level }),
			}
		},
	})
}
export const useHorizontalRuleState = (editor: Editor) => {
	useNodeSchemaWarning(HorizontalRule.name, editor)
	return useEditorState({
		editor,
		selector: () => {
			return {
				isActive: editor.isActive(HorizontalRule.name),
				canSet: editor.can().setHorizontalRule(),
			}
		},
	})
}
export const useOrderedListState = (editor: Editor) => {
	useNodeSchemaWarning(OrderedList.name, editor)
	return useEditorState({
		editor,
		selector: () => {
			return {
				isActive: editor.isActive(OrderedList.name),
				canToggle: editor.can().toggleOrderedList(),
			}
		},
	})
}
export const useTaskListState = (editor: Editor) => {
	useNodeSchemaWarning(TaskList.name, editor)
	return useEditorState({
		editor,
		selector: () => {
			return {
				isActive: editor.isActive(TaskList.name),
				canToggle: editor.can().toggleTaskList(),
			}
		},
	})
}
